import { Country } from "../Country.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const countryNameMap: Record<Country, LocalizedString> = {
	[Country.Czechia]: { [Locale.cs]: "Česká republika", [Locale.en]: "Czech Republic" },
	[Country.Poland]: { [Locale.cs]: "Polsko", [Locale.en]: "Poland" },
	[Country.Germany]: { [Locale.cs]: "Německo", [Locale.en]: "Germany" },
	[Country.Slovakia]: { [Locale.cs]: "Slovensko", [Locale.en]: "Slovakia" },
	[Country.Ukraine]: { [Locale.cs]: "Ukrajina", [Locale.en]: "Ukraine" },
	[Country.Italy]: { [Locale.cs]: "Itálie", [Locale.en]: "Italy" },
	[Country.Belgium]: { [Locale.cs]: "Belgie", [Locale.en]: "Belgium" },
	[Country.France]: { [Locale.cs]: "Francie", [Locale.en]: "France" },
	[Country.Israel]: { [Locale.cs]: "Izrael", [Locale.en]: "Israel" },
	[Country.Japan]: { [Locale.cs]: "Japonsko", [Locale.en]: "Japan" },
	[Country.Austria]: { [Locale.cs]: "Rakousko", [Locale.en]: "Austria" },
	[Country.Slovenia]: { [Locale.cs]: "Slovinsko", [Locale.en]: "Slovenia" },
	[Country.Spain]: { [Locale.cs]: "Španělsko", [Locale.en]: "Spain" },
	[Country.Switzerland]: { [Locale.cs]: "Švýcarsko", [Locale.en]: "Switzerland" },
	[Country.Bulgaria]: { [Locale.cs]: "Bulharsko", [Locale.en]: "Bulgaria" },
	[Country.China]: { [Locale.cs]: "Čína", [Locale.en]: "China" },
	[Country.Finland]: { [Locale.cs]: "Finsko", [Locale.en]: "Finland" },
	[Country.Korea]: { [Locale.cs]: "Korea", [Locale.en]: "Korea" },
	[Country.Lithuania]: { [Locale.cs]: "Litva", [Locale.en]: "Lithuania" },
	[Country.Hungary]: { [Locale.cs]: "Maďarsko", [Locale.en]: "Hungary" },
	[Country.Mexico]: { [Locale.cs]: "Mexiko", [Locale.en]: "Mexico" },
	[Country.Norway]: { [Locale.cs]: "Norsko", [Locale.en]: "Norway" },
	[Country.Netherlands]: { [Locale.cs]: "Nizozemsko", [Locale.en]: "Netherlands" },
	[Country.Turkey]: { [Locale.cs]: "Turecko", [Locale.en]: "Turkey" },
	[Country.USA]: { [Locale.cs]: "USA", [Locale.en]: "USA" },
	[Country.Croatia]: { [Locale.cs]: "Chorvatsko", [Locale.en]: "Croatia" },
	[Country.Canada]: { [Locale.cs]: "Kanada", [Locale.en]: "Canada" },
	[Country.Latvia]: { [Locale.cs]: "Lotyšsko", [Locale.en]: "Latvia" },
	[Country.Neutral]: { [Locale.cs]: "neutrální", [Locale.en]: "Neutral" },
};
